// extracted by mini-css-extract-plugin
module.exports = {"sliderWrp":"slider_sliderWrp__23Xsi","sliderMin":"slider_sliderMin__2rQXJ","sliderMax":"slider_sliderMax__3OpHS"};